/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CertRosetteAltIcon16Light = forwardRef('CertRosetteAltIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1a5 5 0 0 0-4 8v6.088c0 .704.79 1.12 1.37.722L8 14.006l2.63 1.804a.875.875 0 0 0 1.37-.722V9a5 5 0 0 0-4-8ZM4 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm7 4c-.836.628-1.874 1-3 1a4.978 4.978 0 0 1-3-1v4.85l2.505-1.717a.875.875 0 0 1 .99 0L11 14.851V10Z" })));
});
